import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
  operationType: null,
  isHover: {
    hoveredSensorId: null,
    status: false,
  },
  positionEdit: {
    sensorId: null,
    isDraggable: false,
    isActive: false,
    positionUpdated: false,
  },
};

const sensorSlice = createSlice({
  name: "sensor",
  initialState,
  reducers: {
    // create
    createSensorStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
      state.operationType = "create";
    },
    createSensorSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createSensorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateSensorState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateSensorStart(state, action) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
      state.operationType = action.payload?.operationType || "update";
    },
    updateSensorSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateSensorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateSensorState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.operationType = null;
    },
    // delete
    deleteSensorStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteSensorSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteSensorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    // position edit
    resetDeleteSensorState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.positionEdit.positionUpdated = false;
      state.operationType = null;
    },
    // sensor selection
    sensorIsHoverStart(state, action) {
      state.isHover.status = true;
      state.isHover.hoveredSensorId = action.payload;
    },
    sensorIsHoverEnd(state) {
      state.isHover.status = false;
      state.isHover.hoveredSensorId = null;
    },
  },
});

export const {
  createSensorStart,
  createSensorSuccess,
  createSensorFailure,
  resetCreateSensorState,
  updateSensorStart,
  updateSensorSuccess,
  updateSensorFailure,
  resetUpdateSensorState,
  deleteSensorStart,
  deleteSensorSuccess,
  deleteSensorFailure,
  resetDeleteSensorState,
  sensorIsHoverStart,
  sensorIsHoverEnd,
} = sensorSlice.actions;

export default sensorSlice.reducer;
